import { ConstructorInterfaceActionJwtEncode } from '../../../../../interface.type'
export default function EncodeJwtActionInterface({ action }: {
    action: ConstructorInterfaceActionJwtEncode
}) {

    return <div className='ActionInterface'>
        Codificamos en JWT
    </div>

}